// styles.ts
import styled from "styled-components";

/** Contêiner principal do Carousel */
export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 300px;
`;

/** Área que exibe a imagem do slide atual */
export const SlideContainer = styled.div`
  position: absolute;
  inset: 0; /* top: 0; right: 0; bottom: 0; left: 0; */
  background-size: contain; /* Exibe a imagem completa */
  background-repeat: no-repeat; /* Evita repetição da imagem */
  background-position: center; /* Centraliza a imagem */
  transition: transform 0.5s ease-out;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  overflow: hidden;
`;

/** Link que cobre toda a área do slide */
export const SlideLink = styled.a`
  position: absolute;
  inset: 0;
  display: block;
  text-decoration: none;
  color: inherit;
  z-index: 1; /* para ficar abaixo dos botões de seta */
`;

/** Overlay semitransparente por cima da imagem */
export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.1);
`;

/** Container para alinhar o texto no canto */
export const OverlayContent = styled.div`
  position: absolute;
  bottom: 50px; /* Ajuste conforme necessário */
  right: 300px; /* Ajuste conforme necessário */
  color: #fff;
  font-size: 16px;
`;

/** Botão-base para as setas (esquerda e direita) */
export const ArrowButtonBase = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.8);
  border: 4px solid #ececec;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 2; /* Acima do SlideLink para poder clicar */
  &:hover {
    background: #ffffff;
  }
`;

export const ArrowButtonLeft = styled(ArrowButtonBase)`
  left: 16px;
`;

export const ArrowButtonRight = styled(ArrowButtonBase)`
  right: 16px;
`;

/** Contêiner dos “pontinhos” (dots) */
export const DotsWrapper = styled.div`
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 2; /* Também acima do SlideLink */
`;

/** Estilo de cada “pontinho” */
interface DotProps {
  isActive: boolean;
}
export const Dot = styled.button<DotProps>`
  width: ${(props) => (props.isActive ? "16px" : "8px")};
  height: 8px;
  border-radius: 24px;
  background-color: ${(props) =>
    props.isActive ? "#ffffff" : "rgba(255, 255, 255, 0.5)"};
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
`;
